<script>
import Cookie from "js-cookie";
export default {
    name: "AdminLayout",

    methods: {

       logOut() {

          if(!window.confirm(`Confirm log out`)) return;

         Cookie.remove('TW___');
         document.location.replace('/login');
       }
    }
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <aside class="w-64 flex min-h-screen overflow-hidden" aria-label="Sidebar">
           <div class="overflow-y-auto py-4 px-3 bg-gray-50 rounded dark:bg-gray-800 h-full">
              <ul class="space-y-2">
                 <li>
                    <router-link 
                        :to="{ name: `admin.home` }" 
                        :class="$route.name == `admin.home` ? `bg-gray-300` : ``"
                        class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                       <svg class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path><path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path></svg>
                       <span class="ml-3">Dashboard</span>
                    </router-link>
                 </li>
                 <li>
                    <router-link :to="{ name: `admin.call-center` }" 
                        :class="$route.name == `admin.call-center` ? `bg-gray-300` : ``"
                        class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                       <svg class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
                       <span class="flex-1 ml-3 whitespace-nowrap">Call Center</span>
                       <span class="inline-flex justify-center items-center px-2 ml-3 text-sm font-medium text-gray-800 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-300"></span>
                    </router-link>
                 </li>
                 <li>
                    <router-link :to="{ name: `admin.users` }" 
                     :class="$route.name == `admin.users` ? `bg-gray-300` : ``"
                     class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                       <svg class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd"></path></svg>
                       <span class="flex-1 ml-3 whitespace-nowrap">Users</span>
                    </router-link>
                 </li>
                 <li>
                    <router-link :to="{ name: `admin.reports.call` }" 
                     :class="$route.name == `admin.reports.call` ? `bg-gray-300` : ``"
                     class="flex items-center p-2 text-base font-normal text-gray-900 rounded-lg 
                        dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                       <svg class="flex-shrink-0 w-6 h-6 text-gray-500 
                           transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd"></path></svg>
                       <span class="flex-1 ml-3 whitespace-nowrap">Report</span>
                    </router-link>
                 </li>
                 <li>
                    <button @click.prevent="logOut"
                     class="flex items-center px-6 py-2 bg-blue-500 text-base 
                     font-normal text-white rounded-lg">
                       <span class="flex-1 ml-3 whitespace-nowrap">Log Out</span>
                    </button>
                 </li>
              </ul>
           </div>
        </aside>
        <div class="flex-1">
            <router-view></router-view>
        </div>
    </div>
</template>
